import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    flyingCartItem: {
        marginBottom: theme.spacing(2),
        "&:last-child": {
            marginBottom: 0,
        },
    },
    flyingCartItemTitle: {
        color: theme.palette.secondary.main,
        fontWeight: theme.typography.fontWeightRegular,
        marginBottom: theme.spacing(1),
        fontSize: "18px",
    },
}));
